import React from 'react';
import Hero from '../components/Hero';
import Feature from '../components/Feature'
import Footer from '../components/Footer';
import { Stack } from '@chakra-ui/react';

const LandingPage = () => {
  return (
    <Stack spacing={5}> {/* Adjust the spacing here */}
      <Hero />
      <Feature />
      <Footer />
    </Stack>
  );
};

export default LandingPage;
